export default __webpack_public_path__ + "static/media/generic-nursery.d258703b.svg";